<template>
  <div :class="classnames">
    <div :class="`${ns}__section`">
      <template v-if="showPageHeadline">
        <toolbar-page-headline :text="pageHeadline" />
      </template>

      <template v-if="showBackButton">
        <toolbar-back-button v-on:click="handleBackButtonClick" />
      </template>
    </div>

    <div :class="`${ns}__section`">
      <!-- <toolbar-edit-menu :items="editMenuItems" /> -->
      <toolbar-search-button v-if="showSearchButton" />
      <toolbar-share-button v-if="showShareButton" :shareData="shareButtonData" />
      <toolbar-more-menu v-if="showMoreButton" :lists="moreMenuItems" />
    </div>
  </div>
</template>

<script>
  import ToolbarBackButton from '@/components/ToolbarBackButton'

  import ToolbarEditMenu from '@/components/ToolbarEditMenu'
  import ToolbarMoreMenu from '@/components/ToolbarMoreMenu'
  import ToolbarShareButton from '@/components/ToolbarShareButton'
  import ToolbarSearchButton from '@/components/ToolbarSearchButton'
  import ToolbarPageHeadline from '@/components/ToolbarPageHeadline'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'page-toolbar'

  export default {
    name: 'PageToolbar',
    components: {
      'toolbar-back-button': ToolbarBackButton,

      'toolbar-edit-menu': ToolbarEditMenu,
      'toolbar-more-menu': ToolbarMoreMenu,
      'toolbar-page-headline': ToolbarPageHeadline,
      'toolbar-search-button': ToolbarSearchButton,
      'toolbar-share-button': ToolbarShareButton
    },
    mixins: [ bem ],
    props: {
      collectionsMenuItems: {
        type: Array
      },
      editMenuItems: {
        type: Array
      },
      moreMenuItems: {
        type: Array
      },
      pageHeadline: {
        type: String
      },
      shareButtonData: {
        type: Object
      },
      showPageHeadline: {
        default: false,
        type: Boolean
      },
      showBackButton: {
        default: false,
        type: Boolean
      },
      showSearchButton: {
        default: true,
        type: Boolean
      },
      showShareButton: {
        default: true,
        type: Boolean
      },
      showMoreButton: {
        default: true,
        type: Boolean
      }
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleBackButtonClick () {
        this.$emit('back-button-click')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/PageToolbar.vue